import React, { useEffect } from "react";
import { Form, Button, Input, Divider, Row, Col } from "antd";
import { ReactSVG } from "react-svg";
import { InfoCircleOutlined } from "@ant-design/icons";
import PrimaryButton from "../../Buttons/PrimaryButton";

const IntegrationWooCommerceSettingsForm = ({ setting, handleSubmit }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (setting) {
      form.setFieldsValue({ ...setting });
    }
  }, [setting]);

  const handleOnFinish = async values => {
    const params = { ...values };
    handleSubmit(params);
  };

  return (
    <div className="IntegrationSettingsForm IntegrationWooCommerceSettingsForm">
      <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleOnFinish}>
        <div className="FormContent">
          <Row>
            <Col span={16}>
              <Form.Item label="URL" name="woo_commerce_url">
                <Input size="large" placeholder="https://yourcompany.com/wp-admin" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <Form.Item label="Consumer Key" name="woo_commerce_consumer_key">
                <Input size="large" placeholder="a4db08b7-5729-4ba9-8c08-f2df493465a1" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button type="link" className="btn-label">
                Where can I find this information
                <InfoCircleOutlined />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <Form.Item label="Consumer Secret" name="woo_commerce_consumer_secret">
                <Input size="large" placeholder="a4db08b7-5729-4ba9-8c08-f2df493465a1" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button type="link" className="btn-label">
                Where can I find this information
                <InfoCircleOutlined />
              </Button>
            </Col>
          </Row>
        </div>
        <Divider />
        <div className="FormFooter">
          <div className="Left"></div>
          <div className="Right">
            <PrimaryButton
              label="Update"
              htmlType="submit"
              icon={<ReactSVG className="icon" src="/icons/submit.svg" />}
            />
          </div>
        </div>
      </Form>
    </div>
  );
};

export default IntegrationWooCommerceSettingsForm;
